import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, Steps, Popover } from "antd";
import TextInput from "../../components/input/TextInput";
import "./Styles.css";
import { AiOutlineClose } from "react-icons/all";
import { EMAIL_REGX } from "../../config/variables";
import { UserAction } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { formatToNumber } from "../../config/utils";
import RMX from "../../assets/images/b-RMX-1.png";

const AddPlant = ({ count, onChangeStep }) => {
  const dispatch = useDispatch();
  const [currentIndex, setIndex] = useState(0);
  const zipcodeErr = useSelector((state) => state.UserReducer.zipcodeError);

  const [plantInfo, setPlantInfo] = useState([
    {
      name: "",
      email: "",
      address: "",
      zipcode: "",
      phone: "",
    },
  ]);
  const [errors, setErrors] = useState([
    {
      nameError: "",
      emailError: "",
      addressError: "",
      zipcodeError: "",
      phoneError: "",
    },
  ]);
  useEffect(() => {
    const err = [...errors];
    err[currentIndex].zipcodeError = zipcodeErr;
    setErrors(err);

    // setErrors({ ...errors, zipcodeError: zipcodeErr });
  }, [zipcodeErr]);
  console.log("error==>", errors);
  const { Step } = Steps;
  const customDot = (dot, { status, index }) => (
    <Popover
      content={
        <span>
          step {index} status: {status}
        </span>
      }
    >
      {dot}
    </Popover>
  );
  const addNewPlant = () => {
    const arr = [...plantInfo];
    const errorArr = [...errors];
    arr.push({
      name: "",
      email: "",
      address: "",
      zipcode: "",
      phone: "",
    });
    errors.push({
      nameError: "",
      emailError: "",
      addressError: "",
      zipcodeError: "",
      phoneError: "",
    });
    setPlantInfo(arr);
    setErrors(errors);
  };

  const onHandelDelete = (item, index) => {
    const arr = [...plantInfo];
    arr.splice(index, 1);
    setPlantInfo(arr);
  };
  const onHandleChange = (e, index) => {
    const arr = [...plantInfo];
    const err = [...errors];
    arr[index] = {
      ...arr[index],
      [e.target.name]: e.target.value,
    };
    err[index] = {
      ...err[index],
      [`${e.target.name}Error`]: "",
    };
    setPlantInfo(arr);
    setErrors(err);
  };
  const onSubmit = () => {
    const localStorage = window.localStorage.getItem("companyInfo");
    const error = [...errors];
    for (var i = 0; i < plantInfo.length; i++) {
      if (
        !plantInfo[i].name.trim().length ||
        !EMAIL_REGX.test(plantInfo[i].email) ||
        !plantInfo[i].address.trim().length ||
        !plantInfo[i].phone.trim().length ||
        !plantInfo[i].zipcode.trim().length
      ) {
        if (!plantInfo[i].name.trim().length) {
          error[i].nameError = "Name is required.";
        }
        if (!EMAIL_REGX.test(plantInfo[i].email)) {
          error[i].emailError = "Email is required.";
        }
        if (!plantInfo[i].address.trim().length) {
          error[i].addressError = "Address is required.";
        }
        if (!plantInfo[i].phone.trim().length) {
          error[i].phoneError = "Phone is required.";
        }
        if (!plantInfo[i].zipcode.trim().length) {
          error[i].zipcode = "Zipcode is required.";
        }
        setErrors(error);
        return;
      }
    }
    dispatch(UserAction.createLocationReq(plantInfo, () => onChangeStep()));
  };

  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={24} xl={24} lg={24}>
        <Card
          style={{
            boxShadow: 'boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px',
          }}
        >
          <Row>
            <Col
              xl={24}
              lg={24}
              xs={24}
              sm={24}
              md={24}
              style={{
                padding: "15px",
                justifyContent: "start",
                display: "flex",
                marginTop: "20px",
              }}
            >
              <img
                src={RMX}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  backgroundRepeat: "no-repeat",
                  top: "-20px",
                  paddingLeft: "50px",
                }}
              />
            </Col>
          </Row>
          <Steps current={count} progressDot={customDot}>
            <Step title="Register" />
            <Step title="Create Profile" />
            <Step title="Add your plant" />
            <Step title="Personlize" />
            <Step title="Build Catalog" />
            <Step title="Subscription" />
          </Steps>
          <div
            style={{
              width: "90%",
              margin: "auto",
              // boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
              border: "solid #eaeaea 1px",
              padding: "1rem",
              marginTop: "20px",
            }}
          >
            {plantInfo.map((item, index) => {
              console.log("ITEM==>", errors[index]["nameError"]);
              return (
                <>
                  <Row
                    className="login-card"
                    justify="space-between"
                    align="middle"
                  >
                    <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                      <h2 className="text-left">Plant Information</h2>
                    </Col>
                    {!!index && (
                      <Col span={12}>
                        <AiOutlineClose
                          onClick={(e) => onHandelDelete(item, index)}
                        />
                      </Col>
                    )}
                  </Row>
                  <Row
                    justify="center"
                    style={{ paddingRight: "30px", paddingLeft: "30px" }}
                  >
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      xl={24}
                      lg={24}
                      className="cardpadding"
                    >
                      <Row gutter={[30, 0]}>
                        <Col xs={24} lg={12} span={12}>
                          <TextInput
                            label={"Name"}
                            required
                            onChange={(e) => onHandleChange(e, index)}
                            name="name"
                            value={plantInfo[index]["name"]}
                          />
                          <Row justify="end">
                            <Col span={24} className="text-right">
                              {" "}
                              <span className="danger-color text-right">
                                {errors[index]["nameError"] &&
                                  errors[index]["nameError"]}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24} lg={12} span={12}>
                          <TextInput
                            label={"Phone"}
                            required
                            onChange={(e) => onHandleChange(e, index)}
                            name="phone"
                            value={formatToNumber(plantInfo[index]["phone"])}
                          />
                          <Row justify="end">
                            <Col span={24} className="text-right">
                              {" "}
                              <span className="danger-color text-right">
                                {errors[index]["phoneError"] &&
                                  errors[index]["phoneError"]}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24} lg={12} span={12}>
                          <TextInput
                            label={"Plant Email"}
                            required
                            onChange={(e) => onHandleChange(e, index)}
                            name="email"
                            value={plantInfo[index]["email"]}
                          />
                          <Row justify="end">
                            <Col span={24} className="text-right">
                              {" "}
                              <span className="danger-color text-right">
                                {errors[index]["emailError"] &&
                                  errors[index]["emailError"]}
                              </span>
                            </Col>
                          </Row>
                        </Col>

                        <Col xs={24} lg={12} span={12}>
                          <TextInput
                            label={"Zip Code"}
                            required
                            onChange={(e) => onHandleChange(e, index)}
                            name="zipcode"
                            value={plantInfo[index]["zipcode"]}
                            onBlur={() => {
                              dispatch(
                                UserAction.verify_zipcode_req({
                                  zipcode: plantInfo[index]["zipcode"],
                                })
                              );
                              setIndex(index);
                            }}
                          />
                          <Row justify="end">
                            <Col span={24} className="text-right">
                              {" "}
                              <span className="danger-color text-right">
                                {errors[index]["zipcodeError"] &&
                                  errors[index]["zipcodeError"]}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <TextInput
                            label={"Plant Address "}
                            required
                            onChange={(e) => onHandleChange(e, index)}
                            name="address"
                            value={plantInfo[index]["address"]}
                          />
                          <Row justify="end">
                            <Col span={24} className="text-right">
                              {" "}
                              <span className="danger-color text-right">
                                {errors[index]["addressError"] &&
                                  errors[index]["addressError"]}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </>
              );
            })}
          </div>

          <Row
            justify="end"
            gutter={[10, 20]}
            className="cardpadding"
            // style={{ marginBottom: "20px", marginTop: "20px" }}
          >
            <Col
              xs={24}
              sm={24}
              md={10}
              xl={4}
              lg={4}
              // style={{ paddingLeft: "10px" }}
              style={{
                paddingLeft: "10px",
                display: "flex",
                justifyContent: "end",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <Button
                style={{
                  backgroundColor: "#26a69a",
                  color: "#fff",
                  height: "37px",
                  width: "100%",
                }}
                onClick={() => addNewPlant()}
              >
                ADD NEW PLANT
              </Button>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={10}
              xl={4}
              lg={4}
              style={{
                paddingLeft: "10px",
                display: "flex",
                justifyContent: "end",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  height: "37px",
                  width: "100%",
                }}
                onClick={() => onSubmit()}
              >
                PERSONALIZE
              </Button>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default AddPlant;
